import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { fetchCustomers } from "../../features/admin/adminSlice";
import ContainerPage from "../../components/ContainerPage/ContainerPage";
import PageTitle from "../../components/PageTitle/PageTitle";
import TableFooter from "../../components/Pagination/TableFooter";
import AddCustomerModal from "../../components/AddCustomerModal/AddCustomerModal";
import DebounceInput from "../../components/DebouncedSearch/DebouncedSearch";

import { showSnackBar } from "../../components/Snackbar/Snackbar";
import TableContactList from "./Table/TableContactList";


const Customers = () => {
  const dispatch = useDispatch();
  const [reqError, setReqError] = useState('');
  const [valuePagination, setValuePagination] = useState(10);
  const [pagePagination, setPagePagination] = useState(1);
  const [handleDelete, setHandleDelete] = useState('');
  const [data, setData] = useState([]);
  const [isUpdate, setIsUpdate] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [onCreateCustomer, setOnCreateCustomer] = useState(false);

  const requestFetchCustomers = async () => {
    try {
      const limit = parseInt(valuePagination)
      const offset = (pagePagination - 1) * limit
      const response = await dispatch(fetchCustomers({ limit, offset, searchQuery: searchValue }));
      setData(response.payload);
    } catch (error) {
      setReqError(error);
      console.error('An unexpected error occurred:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setData([])
      await requestFetchCustomers()
    }

    fetchData()
  }, [pagePagination, valuePagination, handleDelete, isUpdate, searchValue]);

  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }
    handleReqError()
  }, [reqError])


  return (
    <div className="">
      <ContainerPage>
        <div className="flex justify-between items-center">
          <PageTitle title="Customers List" />
          <AddCustomerModal setUpdateTable={setIsUpdate} setOnCreateCustomer={setOnCreateCustomer} onCreateCustomer={onCreateCustomer} />
        </div>
        <div className="bg-surface border border-divider rounded-lg mt-6 shadow-card">
          <div className="flex flex-row justify-between items-center px-5 py-4 ">
            <DebounceInput value={searchValue} setSearchValue={setSearchValue} placeholder="Search..." />
          </div>
          <TableContactList data={data?.data} setHandleDelete={setHandleDelete} />
          {/* No range label: getAllCustomers sends only limit/offset/pageCount, so there
              is no total to count against. Reading meta.totalCount here just resolved to
              undefined and degraded silently. */}
          <TableFooter page={pagePagination} limit={valuePagination}
            pageCount={data?.data?.meta?.pageCount}
            setPage={setPagePagination} setLimit={setValuePagination} />
        </div>

      </ContainerPage>
    </div>
  );
};

export default Customers;
